import '../../common/bn-action';
import { LitEntity, html } from '../../utility/lit-entity';
import { BnModalMixin } from '../../common/bn-modal-mixin';

class OrganizationAddRelationshipModal extends BnModalMixin(LitEntity) {
  constructor() {
    super();
    this.id = 'organization-add-related-modal';
  }

  renderContents() {
    return html`
      <style>
        bn-modal#reject-probation-modal {
          --modal-min-width: 60%;
          --modal-max-width: 600px;
        }
        h3 {
          margin: 0;
        }
      </style>

      <h3 slot="title">Add Relationship</h3>

      <bn-action
        .href="${this.href}"
        suppressheader
        actionname="add-related-organization"
        submittext="Add Relationship"
        @response="${this._onResponse}"
      ></bn-action>
    `;
  }

  _onResponse(e) {
    this.dispatchEvent(new CustomEvent('response', { detail: e.detail }));
    this.close();
  }
}

window.customElements.define('organization-add-relationship-modal', OrganizationAddRelationshipModal);
